// Category names are stored in English (they are the API values) — only the display text is localised.
export const catLabel = (name, t) => {
  if (!name) return "";
  const key = `cat.${name}`;
  const label = t(key);
  return label === key ? name : label;
};
